import React, { Fragment } from 'react';
import Card from '@material-ui/core/Card';
import { CardContent, CardHeader, IconButton, AppBar } from '@material-ui/core';
import Close from '@material-ui/icons/Close';

import { withStyles } from '@material-ui/core/styles';

import { Filters } from './../../services/Filters';

const _filters = new Filters();

const styles = theme => ({
  content: {
    color: theme.palette.primary.contrastText,
  }
});

const DetailsCard = (props) => {

  const { appLanguage, cardStyles, contentStyles, classes } = props;

  return (
    <Fragment>
      <Card className={props.className} style={{ maxHeight: '85vh', ...cardStyles}}>
        <AppBar position='static'>
          <CardHeader
            classes={{
              title: classes.content,
              subheader: classes.content,
            }}
            title={_filters.translate(props.title, appLanguage)}
            subheader={_filters.translate(props.subheader, appLanguage)}
            action={
              <IconButton onClick={props.onClose} classes={{root: classes.content}}>
                <Close />
              </IconButton>
            }
          />
        </AppBar>
        <CardContent style={{position: 'relative', height: '100%', maxHeight: '63vh', overflowY: 'auto', ...contentStyles}} >
          {props.children}
        </CardContent>
      </Card>
    </Fragment>
  );
}

export default withStyles(styles)(DetailsCard);


// WEBPACK FOOTER //
// ./src/components/containers/DetailsCard.js